/**
 * Aether Jewels Theme JS
 * Minimal, performance-focused interactions
 */

(function() {
  'use strict';

  // Mobile menu toggle (placeholder for future expansion)
  const initMobileMenu = () => {
    const menuToggle = document.querySelector('[data-menu-toggle]');
    if (!menuToggle) return;

    menuToggle.addEventListener('click', () => {
      document.body.classList.toggle('menu-open');
    });
  };

  // Smooth reveal on scroll for product cards
  const initRevealOnScroll = () => {
    const cards = document.querySelectorAll('.product-card');
    if (!cards.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    cards.forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(card);
    });
  };

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initRevealOnScroll();
  });
})();

/* Wishlist (localStorage) */
(function() {
  var KEY = 'monteluvia_wishlist';
  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) { return []; }
  }
  function setList(list) { localStorage.setItem(KEY, JSON.stringify(list)); }
  function toggle(handle) {
    var list = getList();
    var i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1); else list.push(handle);
    setList(list);
    syncUI();
  }
  function syncUI() {
    var list = getList();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var h = btn.getAttribute('data-wishlist-toggle');
      var on = list.indexOf(h) >= 0;
      btn.classList.toggle('is-active', on);
      if (btn.tagName === 'BUTTON' && btn.textContent.indexOf('Save') !== -1) {
        btn.textContent = on ? '♥ Saved' : '♡ Save to wishlist';
      }
    });
  }
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.getAttribute('data-wishlist-toggle'));
  });
  document.addEventListener('DOMContentLoaded', syncUI);
})();

/* Recently viewed */
(function() {
  var KEY = 'monteluvia_recent';
  var handle = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product
    ? null : null;
  // Store from product page body attribute if present
  document.addEventListener('DOMContentLoaded', function() {
    var el = document.querySelector('[data-product-handle]');
    if (!el) return;
    var h = el.getAttribute('data-product-handle');
    if (!h) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) {}
    list = list.filter(function(x) { return x !== h; });
    list.unshift(h);
    list = list.slice(0, 8);
    localStorage.setItem(KEY, JSON.stringify(list));
  });
})();
